import type { GetV1ScenariosIdPathParams, GetV1ScenariosId200, GetV1ScenariosId404, GetV1ScenariosId422, GetV1ScenariosIdQueryResponse } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { scenarioSchema } from './scenarioSchema'
import { z } from 'zod'

export const getV1ScenariosIdPathParamsSchema = z.object({
  id: z.number().nullable(),
}) as unknown as ToZod<GetV1ScenariosIdPathParams>

export type GetV1ScenariosIdPathParamsSchema = GetV1ScenariosIdPathParams

/**
 * @description The requested scenario
 */
export const getV1ScenariosId200Schema = z.lazy(() => scenarioSchema) as unknown as ToZod<GetV1ScenariosId200>

export type GetV1ScenariosId200Schema = GetV1ScenariosId200

/**
 * @description Scenario not found
 */
export const getV1ScenariosId404Schema = z.object({
  message: z.string(),
}) as unknown as ToZod<GetV1ScenariosId404>

export type GetV1ScenariosId404Schema = GetV1ScenariosId404

/**
 * @description Invalid id error
 */
export const getV1ScenariosId422Schema = z.object({
  success: z.boolean(),
  error: z.object({
    issues: z.array(
      z.object({
        code: z.string(),
        path: z.array(z.union([z.string(), z.number()])),
        message: z.string().optional(),
      }),
    ),
    name: z.string(),
  }),
}) as unknown as ToZod<GetV1ScenariosId422>

export type GetV1ScenariosId422Schema = GetV1ScenariosId422

export const getV1ScenariosIdQueryResponseSchema = z.lazy(() => getV1ScenariosId200Schema) as unknown as ToZod<GetV1ScenariosIdQueryResponse>

export type GetV1ScenariosIdQueryResponseSchema = GetV1ScenariosIdQueryResponse